import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { StyledSingleFeaturedProduct } from './SingleFeaturedProduct.styled';
import { ProductCard } from '~/components/ProductCard/ProductCard';
import { Wrapper } from '~/styles/Wrapper.styled';

import {
  IProduct,
  IntentSlug,
  ContentfulPageSection,
  ContentCard,
} from '~/types/types';
import { intentSlugs } from '../../types/constants';

export const SingleFeaturedProduct: React.FC<SingleFeaturedProductData> = ({
  section,
}) => {
  const contentCard = section.media.find(
    (m: {__typename: string}) => m.__typename === 'ContentfulContentCard'
  ) as ContentCard;

  const product = section.media.find(
    (m: {__typename: string})=> m.__typename === 'ContentfulProduct'
  ) as IProduct;

  return (
    <StyledSingleFeaturedProduct>
      <div className="background">
        <GatsbyImage
          image={contentCard.media.gatsbyImageData}
          alt={contentCard.media.title}
        />
      </div>

      <Wrapper gutter={false} width="wide">
        <div className="text">
          <h4>{contentCard.label}</h4>
          <h3>{contentCard.title}</h3>

          <article>
            <p
              dangerouslySetInnerHTML={{
                __html: contentCard.description.childMarkdownRemark.html,
              }}
            />
          </article>
        </div>

        <div className="product">
          <ProductCard
            product={product}
            intentCollections={product.collection?.filter(col =>
              intentSlugs.includes(col.slug as IntentSlug)
            )}
            showOnHover={false}
          />
        </div>
      </Wrapper>
    </StyledSingleFeaturedProduct>
  );
};

export interface SingleFeaturedProductData {
  section: ContentfulPageSection;
}
